import React, { Suspense, lazy, useEffect, useState } from 'react';
import { getConsent, onConsentChange } from '../utils/consent';

const ConsentTrackers = lazy(() => import('./ConsentTrackers'));

const wantsTrackers = (consent) => consent.analytics === true || consent.marketing === true;

/**
 * The tracker loaders (GA's gtag.js, Clarity, Meta / TikTok / Snap) are code
 * only a consenting visitor needs: they load once analytics or marketing is
 * allowed (a stored choice or the banner). Once mounted, ConsentTrackers
 * handles every later change, withdrawal included.
 */
const LazyTrackers = () => {
  const [on, setOn] = useState(() => wantsTrackers(getConsent()));

  useEffect(() => {
    if (on) return undefined;
    return onConsentChange((consent) => { if (wantsTrackers(consent)) setOn(true); });
  }, [on]);

  if (!on) return null;
  return <Suspense fallback={null}><ConsentTrackers /></Suspense>;
};

export default LazyTrackers;
